/*eslint-disable */
import React, { Component } from 'react';
import tableau from 'tableau-api';

class ViewReports extends Component {

  componentDidMount() {
    this.initViz();
  }

  initViz() {
    const vizUrl = 'https://prodbitabcrp.jnj.com/#/site/ISRMRiskMetrics/views/xIAMuserapplicationmetrics_17099115725100/xIAMuserapplicationmetrics?%3Aiid=1';
    const vizContainer = this.vizContainer;
    // const options = { width: '98.5vw',height: '92vh',};
    const viz = window.tableau.VizManager.getVizs()[0];
    if (viz) {
      viz.dispose();
    }
    new window.tableau.Viz(vizContainer, vizUrl);
  }

  render() {
    return (
      <div className='vizDiv' style={{width:'98.5vw',height: '92vh'}} ref={(div) => { this.vizContainer = div }}>
      </div>
    )
  }
}

export default ViewReports;